import BillingsOrderRelatedCargoRailyRequest from "../../../../../api/raily/billings/order/related/taxi-raily/billings-order-related-taxi-raily.request";
import BillingsOrderRelatedCargoRailyParams from "./billings-order-related-cargo-raily-params";

const createRequest = (
  params: BillingsOrderRelatedCargoRailyParams,
): BillingsOrderRelatedCargoRailyRequest => {
  return {
    orderUuid: params.orderUuid,
  };
};

const billingsOrderRelatesCargoRailyParamsFactory = {
  createRequest,
};

export default billingsOrderRelatesCargoRailyParamsFactory;
